export const name = 'gzCard';

/**
 * @ngdoc directive
 * @name gazelle.components.dashboard.card.directive:gzCard
 *
 * @param {string=} gzCardType. Type name for card template to load
 * @param {string=} gzCardSettings. Settings to pass to the card controller
 *
 * @description
 * `<gz-card>` is a widget that displays application specific data.
 *
 * @usage
 * ```html
 * <gz-card
 *   gz-card-type="account.account"
 *   gz-card-settings="controller.settings"
 * >
 *
 * ```
 */
export default function gzCard($compile) {
  //noinspection BadExpressionStatementJS
  'ngInject';


  var directive = {
    restrict: 'E',
    scope: {
      gzCardType: '=',
      gzCard: '=?',
    },
    //template: require('./card.jade'),
    link: gzCardLink,
    controller: gzCardController,
    controllerAs: 'vm',
    bindToController: true
  };

  return directive;

  //////////////////////
  // Private functions
  function gzCardLink(scope, element, attrs) {
    let cardElement = $compile(`<${scope.vm.gzCardType} layout-fill layout='column' gz-card='vm.gzCard'"></${scope.vm.gzCardType}>`)(scope);
    element.append(cardElement[0]);
  }

  /** @ngInject */
  function gzCardController($scope) {
    // Constants

    // Variables

    // Controller
    var vm = this;

    activate();

    //////////////////
    function activate() {
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/dashboard/card/card.directive.js